import React, { useState } from 'react';
import { t } from 'i18next';
import TabPanel from '@mui/lab/TabPanel';
import TabMenu from '../util/TabMenu';
import CrmContactTypes from '../crmComponents/CrmContactTypes';
import CrmOrganisationTypes from '../crmComponents/CrmOrganisationTypes';
import CrmProjectTypes from '../crmComponents/CrmProjectTypes';
import CrmContactFields from '../crmComponents/CrmContactFields';
import CrmOrganisationFields from '../crmComponents/CrmOrganisationFields';

type TopTab = 'contacts' | 'organisations' | 'projects';

export default function CrmSettings() {
  const [topTab, setTopTab] = useState<TopTab>('contacts');

  return (
    <div className='text-[var(--text-color)]'>
      <TabMenu
        value={topTab}
        onChange={(v: string) => setTopTab(v as TopTab)}
        tabs={[
          { label: t('Contacts'), value: 'contacts' },
          { label: t('Organisations'), value: 'organisations' },
          { label: t('Projects'), value: 'projects' },
        ]}
      >
        <TabPanel value='contacts' sx={{ padding: '0 0 32px 0' }}>
          <CrmContactTypes />
          <CrmContactFields />
        </TabPanel>

        <TabPanel value='organisations' sx={{ padding: '0 0 32px 0' }}>
          <CrmOrganisationTypes />
          <CrmOrganisationFields />
        </TabPanel>

        <TabPanel value='projects' sx={{ padding: '0 0 32px 0' }}>
          <CrmProjectTypes />
        </TabPanel>
      </TabMenu>
    </div>
  );
}
